/* eslint-disable no-loop-func */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

const createMarkerFromCoords = (lat, lng) => {
  const { google } = window;

  const position = {
    lat,
    lng,
  };

  window.map.setCenter(position);

  // center the map over the result
  // place a marker at the location
  const marker = new google.maps.Marker({
    map,
    position,
  });
};

const codeAddress = address => {
  const { google, geocoder } = window;
  geocoder.geocode({ address }, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK) {
      window.map.setCenter(results[0].geometry.location);
      // center the map over the result
      // place a marker at the location
      const marker = new google.maps.Marker({
        map,
        position: results[0].geometry.location,
      });
    }
  });
};

const initCareersMap = () => {
  const $map = document.getElementById('map-canvas');
  if ($map === null) {
    return;
  }
  const location = $map.dataset.locatiom;

  const { google } = window;
  window.geocoder = new google.maps.Geocoder();
  const latlng = new google.maps.LatLng(53.3496, -6.3263);
  const mapOptions = {
    zoom: 15,
    center: latlng,
  };
  window.map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  if ($map.dataset.lat && $map.dataset.lng) {
    createMarkerFromCoords(parseFloat($map.dataset.lat), parseFloat($map.dataset.lng));
    return;
  }
  codeAddress(location); // call the function.
};

const enableMapBlocks = () => {
  const mapWrappers = document.querySelectorAll('.deepsea-map');

  if (mapWrappers.length === 0) {
    return;
  }

  // Init each map
  mapWrappers.forEach(mapWrapper => {
    const { google } = window;
    window.geocoder = new google.maps.Geocoder();
    const latlng = new google.maps.LatLng(53.3496, -6.3263);
    const mapId = mapWrapper.getAttribute('id');
    const mapOptions = {
      zoom: 15,
      center: latlng,
    };

    const locations = JSON.parse(mapWrapper.dataset.locations.replace(/'/g, '"'));

    const map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    let i = 0;

    const { geocoder } = window;

    // Create empty LatLngBounds object.
    const bounds = new google.maps.LatLngBounds();
    for (i = 0; i < locations.length; i += 1) {
      // Convert the location into an array.
      const infoWindowLocation = locations[i].split(',');

      // Split the array to get the first line and the rest separated.
      // First line will be the title. Note: muatation on infoWindowLocation. Desired.
      const infoWindowTitle = infoWindowLocation.shift();

      const infoWindowString = `
      <div class="poi-info-window gm-style">
        <div class="title full-width">${infoWindowTitle}</div>
        <div class="address">
          ${infoWindowLocation
            .map(line => `<div class="address-line full-width">${line}</div>`)
            .join('')}
        </div>
      </div>
    `;

      const infowindow = new google.maps.InfoWindow({
        content: infoWindowString,
      });

      geocoder.geocode({ address: locations[i] }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location);

          const marker = new google.maps.Marker({
            map,
            position: results[0].geometry.location,
          });

          marker.addListener('click', () => {
            infowindow.open(map, marker);
          });

          bounds.extend(marker.position);
          map.fitBounds(bounds);

          const listener = google.maps.event.addListener(map, 'idle', () => {
            if (map.getZoom() > 15) {
              map.setZoom(15);
            }

            google.maps.event.removeListener(listener);
          });
        }
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  enableMapBlocks();
  initCareersMap();
});
